import { GREY_B, GREY_S, RED_G } from 'app/constants/Colors';

export const AUTH_BUTTON_CONTAINER_STYLE = {
  display:        'flex',
  alignItems:     'center',
  justifyContent: 'space-between',
};

export const AUTH_ALERT_CONTAINER_STYLE = {
  marginBottom: '2em',
};

export const AUTH_ACTION_LINK = {
  color: GREY_B,
  textDecoration: 'none',
};

export const AUTH_PARAGRAPH_STYLE = {
  color: GREY_S,
};

export const AUTH_ERROR_STYLE = {
  color: RED_G,
};

export const AUTH_SEPARATOR_TEXT = {
  color: GREY_B,
};
